import { ChromeMessageType } from '../types';
import { getChromeRuntime } from '../chrome/wrappers';

export const sendExtensionConfiguredMessage = () =>
  getChromeRuntime().sendMessage({
    type: ChromeMessageType.EXTENSION_CONFIGURED,
  });

export const registerExtensionConfiguredListener = (callback: () => void) =>
  getChromeRuntime().onMessage.addListener(
    message =>
      message.type === ChromeMessageType.EXTENSION_CONFIGURED && callback()
  );
